import { api } from '@/lib/api';

export const inventoryService = {
  async getAll() {
    const { data } = await api.get('/inventory');
    return { data };
  },

  async create(body) {
    const { data } = await api.post('/inventory', body);
    return { data };
  },

  async update(id, body) {
    const { data } = await api.patch(`/inventory/${id}`, body);
    return { data };
  },

  async delete(id) {
    await api.delete(`/inventory/${id}`);
    return { success: true };
  },
};
